import { FETCH_CATALOG_APP_INSTANCE } from '@/pages/SpaceCatalogAppDetailsPage/actionTypes'
import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import { FETCH_CONNECTOR_LOGS, FETCH_CUSTOM_CONNECTOR_INSTANCE } from './actionTypes'

export const fetchConnectorInstance = (connectorInstanceId: string, currentSpaceId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/appinstances/${connectorInstanceId}`,
        FETCH_CATALOG_APP_INSTANCE,
        { headers: { 'x-workgrid-space': currentSpaceId } },
        { service: 'apps' }
      )
    )
  }
}

export const fetchCustomConnectorInstance = (connectorInstanceId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/:spaceId/connectorinstances/${connectorInstanceId}`,
        FETCH_CUSTOM_CONNECTOR_INSTANCE,
        { method: 'GET' },
        { args: { spaceId: ':spaceId' } }
      )
    )
  }
}

export const fetchConnectorLogs = (search: object): AppThunk => {
  return dispatch => {
    dispatch(request('/connector/logs', FETCH_CONNECTOR_LOGS, { search }, { service: 'audit' }))
  }
}
